import { authHandler } from './auth-handler';
import { requestErrorHandler, responseErrorHandler } from './error-handler';
import store from '@/store';
import { modulesName } from '@/store';

let activeRequests = 0;

const showLoading = () => {
  activeRequests++;
  store.dispatch(`${modulesName.appModuleName}/setLoading`, true);
};

const hideLoading = () => {
  if (activeRequests > 0) activeRequests--;
  if (activeRequests === 0) {
    store.dispatch(`${modulesName.appModuleName}/setLoading`, false);
  }
};

const createRequestInterceptor = () => ({
  onFulfilled: (config) => {
    showLoading();
    authHandler(config);
    return config;
  },
  onRejected: (error) => {
    hideLoading();
    requestErrorHandler(error);
    return Promise.reject(error);
  },
});

const createResponseInterceptor = () => ({
  onFulfilled: (response) => {
    hideLoading();
    return response;
  },
  onRejected: (error) => {
    hideLoading();
    responseErrorHandler(error);
    return Promise.reject(error);
  },
});

export const requestInterceptor = createRequestInterceptor();
export const responseInterceptor = createResponseInterceptor();
export const requestInterceptorDS = createRequestInterceptor();
export const responseInterceptorDS = createResponseInterceptor();
